import { useState, useEffect } from "react";
import { Route, Switch, useLocation } from "wouter";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { MenuOverlay } from "@/components/layout/menu-overlay";
import { HomePage } from "@/pages/home";
import { BrandPage } from "@/pages/brand";
import { ArticlePage } from "@/pages/article";
import { DispatchPage } from "@/pages/dispatch";
import { GalleryPage } from "@/pages/gallery";
import "./index.css";

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);
  return null;
}

export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [, setLocation] = useLocation();

  const handleNavigate = (path: string) => {
    setIsMenuOpen(false);
    setLocation(path);
  };

  return (
    <div
      className="min-h-screen text-[#293129] selection:bg-[#1D4C74] selection:text-[#ECE9E0] bg-[#ECE9E0]"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <Header isMenuOpen={isMenuOpen} onToggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
      <MenuOverlay isOpen={isMenuOpen} onNavigate={handleNavigate} />

      <ScrollToTop />

      <main className="min-h-screen">
        <Switch>
          <Route path="/" component={HomePage} />
          <Route path="/brand" component={BrandPage} />
          <Route path="/article" component={ArticlePage} />
          <Route path="/dispatch" component={DispatchPage} />
          <Route path="/gallery" component={GalleryPage} />
        </Switch>
      </main>

      <Footer />
    </div>
  );
}

export default App;
